<template>
	<v-card :color="color" :dark="dark" rounded :elevation="elevation" style="position: relative;">
		<v-btn
				v-if="icon"
				icon
				x-small
				style="position: absolute; top: 2px; right: 2px; z-index: 1;"
				@click.stop="$emit('click:icon')"
		>
			<v-icon size="16" :color="iconColor">{{ icon }}</v-icon>
		</v-btn>
		<v-progress-linear absolute indeterminate color="white" v-if="loading"></v-progress-linear>
		<v-card-title>
			<v-row>
				<v-col :class="classContent" :style="styleContent">
					<slot v-if="!loading"></slot>
					<v-skeleton-loader v-else class="mx-auto mt-3" width="100%" height="20" type="text"></v-skeleton-loader>
				</v-col>
			</v-row>
		</v-card-title>
		<v-divider></v-divider>
		<v-tooltip bottom max-width="280" :disabled="!infoTooltip">
			<template v-slot:activator="{ on, attrs }">
				<v-card-text v-bind="attrs" v-on="on">
					<v-row>
						<v-col :class="classTitle" :style="styleTitle">
							{{title}}
							<v-icon v-if="infoTooltip" size="12" :color="iconColor" style="vertical-align: middle;">mdi-information-outline</v-icon>
							<div v-if="subtitle" class="text-truncate" :style="styleSubtitle">{{subtitle}}</div>
						</v-col>
					</v-row>
				</v-card-text>
			</template>
			<span>{{ infoTooltip }}</span>
		</v-tooltip>
	</v-card>
</template>

<script>
export default {
	name: "CardDashboard",
	props: {
		title: {},
		color: { default: "primary" },
		dark: { default: true },
		classContent: {
			default:
				"py-1 px-8 text-center font-weight-bold text--white text-h6 text-truncate",
		},
		styleContent: { default: "color: #FFF !important;" },
		classTitle: { default: "pa-1 text-center text-truncate" },
		styleTitle: {},
		subtitle: {},
		styleSubtitle: { default: "font-size: 0.7rem; font-weight: normal; opacity: 0.85;" },
		icon: {},
		iconColor: { default: "white" },
		infoTooltip: {},
		loading: {},
		elevation: {},
	},
};
</script>